export default function setValidFieldsForCurrentUser({ state }) {
  let { registrating, currentUser } = state.get('client')
  if (currentUser) {
    let common = registrating.current.common
    const { currentClient: { validFrom, validTo } } = currentUser
    if (common.validFrom && validFrom) {
      state.merge('client.registrating.current.common.validFrom', {
        value: validFrom
      })
    }
    if (common.validTo && validTo) {
      state.merge('client.registrating.current.common.validTo', {
        value: validTo
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/user/actions/setValidFieldsForCurrentUser.js